import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { ActivatedRoute } from '@angular/router';
import { NumberCardsService } from '../number-cards.service';
import {TopicService } from '../topic.service';
import { Location } from '@angular/common';
import { TSuperExerciseComponent } from '../t-super-exercise/t-super-exercise.component';

@Component({
  selector: 'app-t-number-cards-reduce-bucket',
  templateUrl: './t-number-cards-reduce-bucket.component.html',
  styleUrls: ['./t-number-cards-reduce-bucket.component.css']
})
export class TNumberCardsReduceBucketComponent extends TSuperExerciseComponent{

  representation: string;
  representationSpec: any = undefined;
  helptext: string = "symbols";
  useBuckets:boolean = false;
  visualRepresentation: string ="card";
  cards: number[] = [];
  count: number[] = [];

  //helper
  private value: number = 0;

  constructor(protected activatedRoute: ActivatedRoute, public numberCardsService: NumberCardsService, protected topicService: TopicService, protected _location: Location) {
    super(activatedRoute, numberCardsService, topicService);
    this.type = "cardRepresentationReduce";
    this.title = this.get("numberCardsReductionName");
   }

  generateDefinition(){
    let definition = super.generateDefinition();
    definition.image = "./assets/images/dataRepresentationReduce.png";
    definition.key="dataRepresentation%cardRepresentationReduce%";
    if(this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.key = definition.key.concat(this.representation, "%", this.representationSpec.toString().replace(new RegExp(" ", 'g'), ""), "%", this.cards.toString(), "%", this.visualRepresentation);
    definition.typespecifics.givenCards = [];
    for(let card of this.cards){
      definition.typespecifics.givenCards.push(this.count[card]);
    }
    definition.typespecifics.visualRepresentation = this.visualRepresentation;
    if(this.visualRepresentation=="position"){
      definition.useBucket = false;
    } else{
      definition.typespecifics.useBucket = this.useBuckets;
    }
    definition.level=(this.visualRepresentation=="card"?2:3);
    return definition;
  }

   /** sets information based on configuration */
   setInformationWithConfiguration(){
    super.setInformationWithConfiguration();
    this.cards = this.numberCardsService.getCards(this.representation, this.representationSpec);
    let count = this.configuration.typespecifics.givenCards;
    let index: number = 0;
    for(let card of this.cards){
      this.count[card] = count[index];
      index++;
    }
    this.useBuckets = this.configuration.typespecifics.useBucket;
    this.visualRepresentation = this.configuration.typespecifics.visualRepresentation;
  }

  /** computes and sets the cards */
  onChangeRepr() {
    super.onChangeRepr();
    this.count = this.numberCardsService.getCount(this.cards);
  }

   /** adds a card of the given value 
   * @param {number} card - value of card to add
  */
 addedCard(card: number): void {
  this.count[card]++;
  this.value += card;
}

/** removes a card of the given value 
 * @param {number} card - value of card to remove
*/
removeCard(card: number): void {
  this.count[card]--;
  this.value -= card;
}

/** resets all the variables */
reset(){
  super.reset();
  this.title = this.get("numberCardsReductionName");
  this.representation = undefined;
  this.representationSpec = undefined;
  this.helptext = "symbols";
  this.cards = [];
  this.count = [];
}

generate(){
  let representationId = Math.floor(Math.random() * 4);
  switch (representationId) {
    case 0:
      this.representation = "nary";
      this.representationSpec = Math.floor(Math.random() * 8 + 2);
      break;
    case 1:
      this.representation = "hexadecimal";
      break;
    case 2:
      this.representation = "roman";
      break;
    case 3:
      this.representation = "etruscan";
      break;
  }
  this.title = this.get("numberCardsReductionName");
  this.onChangeRepr();
  let value = 0;
  for(let card of this.cards){
    this.count[card] = Math.floor(Math.random() * Math.max(0,Math.min(((this.maxNumber() - value)/card - 2), 20)));
    value = this.numberCardsService.getValue(this.count);
  }
}

getMax(card:number):number{
  let value = this.numberCardsService.getValue(this.count);
  value = value - card * this.count[card];
  let result = Math.floor((this.maxNumber() - value-1) / card);
  return result;
}

floor(card){
  this.count[card] = Math.floor(this.count[card]);
}

}
